import { render, staticRenderFns } from "./page-tips.vue?vue&type=template&id=0f68c471&scoped=true"
import script from "./page-tips.vue?vue&type=script&lang=js"
export * from "./page-tips.vue?vue&type=script&lang=js"
import style0 from "./page-tips.styl?vue&type=style&index=0&id=0f68c471&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68c471",
  null
  
)

export default component.exports